import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderApiConfiguration } from '../order-api-configuration';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';

@Injectable({
    providedIn: 'root'
})
export class SupplementaryAmountSetupService extends ServiceBase {

    private actionUrl: string;
    private _url: string;
    private _applySupplementaryUrl: string;
    private _allowedToShowSupplementaryButtonUrl: string;
    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._url = this.actionUrl + _configuration.SupplementaryAmountSetup.url;
        this._applySupplementaryUrl = this.actionUrl + _configuration.SupplementaryAmountSetup.applySupplementary;
        this._allowedToShowSupplementaryButtonUrl = this.actionUrl + _configuration.SupplementaryAmountSetup.AllowedToShowSupplementaryButton;
    }

    get = (): Observable<any> => {
        return this._http.get<any>(this._url);
    }

    post = (data: any): Observable<any> => {
        return this._http.post<any>(this._url, data);
    }

    update = (data: any): Observable<any> => {
        return this._http.put<any>(this._url, data);
    }

    applySupplementary = (statementId: any): Observable<any> => {
        return this._http.post<any>(`${this._applySupplementaryUrl}?statementId=${statementId}`, null);
    }

    isAllowedToShowSupplementaryButton = (statementId: any): Observable<any> => {
        return this._http.get<any>(`${this._allowedToShowSupplementaryButtonUrl}?statementId=${statementId}`);
    }
}
